import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
import SavePage from'./components/sgsaa/save'
import Privacy from './components/Term&pri/priv/privacy'
import Termcond from './components/Term&pri/termcon/termcond'
import Grow from './components/pages/grow/grow'
import Individual from './components/pages/secure/individual'
import Business from './components/pages/Analyze/business'
import Contact from './components/contact/Contact'
import Planner from'./components/pages/plaanerform/plaaneerfrm'
import Businesss from './components/pages/Buinesspage/business225'
import Achieve from'./components/pages/Achieve/achieve'
import Secure from'./components/pages/securee/secure'
import AboutUs  from './components/aboutuss/aboutus'
import Blog from './components/pages/blog/smfblog'
import FinLitDashboard from './components/Finlitdashb/SMFfinlidashboard'
import Builder from './components/SMFBuilder/builder'
import Game from './components/SMFGAME/smfgame'


import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";
import { Import } from 'lucide-react'

  const router = createBrowserRouter([
    {
      path: "/",
      element: <App/>,
    },
    {
        path: "save",
        element: <SavePage/>,
      },
   {
      path: "privacy",
      element: <Privacy/>,
    },
    {
      path: "term",
      element: <Termcond/>,
    },
    {
      path: "individual",
      element: <Grow/>,
    },
    {
      path: "individuall",
      element: <Individual/>,
    },

    {
      path: "business1",
      element: <Business/>,
    },
    {
      path: "contact",
      element: <Contact/>,
    },
    {
      path: "explore",
      element: <Planner/>,
    },
    {
      path:"business",
      element:<Businesss/>
    },
    
    {
      path:"achieve",
      element:<Achieve/>
    },

    {
      path:"secure",
      element:<Secure/>
    },

    {
      path:"aboutus",
      element:<AboutUs/>

    },

    {
      path:"blog",
      element:<Blog/>

    },

    {
      path:"finlit",
      element:<FinLitDashboard/>
    },

    {
      path:"builder",
      element:<Builder/>
    },

    {
      path:"smfgame",
      element:<Game/>
    }


    
    
    

  ]);
  


ReactDOM.render(<RouterProvider router={router}/>, document.querySelector("#root"))
